import { render, staticRenderFns } from "./CommentInputBox.vue?vue&type=template&id=5e2c69c0&scoped=true&"
import script from "./CommentInputBox.vue?vue&type=script&lang=js&"
export * from "./CommentInputBox.vue?vue&type=script&lang=js&"
import style0 from "./CommentInputBox.vue?vue&type=style&index=0&id=5e2c69c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2c69c0",
  null
  
)

export default component.exports